// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bucketPopupMainContainer[data-v-a6c73f08]{position:relative;height:100%;width:555px}", ""]);
// Exports
module.exports = exports;
